import type { CategorisedSearchGroups } from './categoriseSearchGroups';
import type { GroupedSearchStats } from './groupSearchStats';

export const ANALYTICS_CSV_HEADERS = [
  'Category',
  'Count',
  'Natural language query',
  'Search types',
  'Destinations',
  'Landmarks',
  'Properties',
  'Date type',
  'Duration',
  'Dates',
  'Flexible months',
  'Occupancy',
  'Prefix matched places',
  'Prefix matched properties',
] as const;

export type AnalyticsCsvSection = {
  key: keyof CategorisedSearchGroups;
  title: string;
};

export type AnalyticsCsvRow = Record<(typeof ANALYTICS_CSV_HEADERS)[number], string | number>;

const CSV_LIST_SEPARATOR = '; ';

function joinList(values: Array<string>): string {
  return values.join(CSV_LIST_SEPARATOR);
}

function toCsvRow(group: GroupedSearchStats, category: string): AnalyticsCsvRow {
  return {
    Category: category,
    Count: group.count,
    'Natural language query': group.naturalLanguageQuery,
    'Search types': joinList(group.destinationTypes),
    Destinations: joinList(group.destinationIds),
    Landmarks: joinList(group.landmarkIds),
    Properties: joinList(group.propertyIds),
    'Date type': joinList(group.dateTypes),
    Duration: joinList(group.durationTypes),
    Dates: joinList(group.dateRanges),
    'Flexible months': joinList(group.flexibleMonths),
    Occupancy: joinList(group.occupancies),
    'Prefix matched places': joinList(group.prefixMatchedGeometryNames),
    'Prefix matched properties': joinList(group.prefixMatchedOfferNames),
  };
}

export function buildAnalyticsCsvRows(
  sections: ReadonlyArray<AnalyticsCsvSection>,
  categorised: CategorisedSearchGroups,
): Array<AnalyticsCsvRow> {
  return sections.flatMap((section) => categorised[section.key].map((group) => toCsvRow(group, section.title)));
}

export function buildAnalyticsCsvFilename(startDate: string, inclusiveEndDate: string): string {
  return `search-analytics_${startDate}_to_${inclusiveEndDate}.csv`;
}
